/**
 * 客户端信息收集工具
 * 用于埋点功能，收集浏览器、操作系统、设备等信息
 */

function detectOS() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  if (/windows/i.test(userAgent)) return 'Windows'
  if (/macintosh|mac os x/i.test(userAgent)) return 'macOS'
  if (/linux/i.test(userAgent)) return 'Linux'
  if (/android/i.test(userAgent)) return 'Android'
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return 'iOS'
  return 'Unknown'
}

function detectBrowser() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  if (userAgent.indexOf('Firefox') > -1) return 'Firefox'
  if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) return 'Opera'
  if (userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Edg') === -1) return 'Chrome'
  if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) return 'Safari'
  if (userAgent.indexOf('Edg') > -1) return 'Edge'
  return 'Unknown'
}

function detectDeviceType() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  const width = window.screen.width || window.innerWidth
  if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
    return width < 768 ? 'mobile' : 'tablet'
  }
  return width >= 1024 ? 'desktop' : (width >= 768 ? 'tablet' : 'mobile')
}

function detectNetwork() {
  try {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
    if (connection) {
      return connection.type || connection.effectiveType || 'unknown'
    }
    return navigator.onLine ? 'online' : 'offline'
  } catch (e) {
    return 'unknown'
  }
}

export function collectClientInfo() {
  try {
    return {
      user_agent: navigator.userAgent || '',
      os: detectOS(),
      browser: detectBrowser(),
      device_type: detectDeviceType(),
      screen_width: window.screen.width || 0,
      screen_height: window.screen.height || 0,
      network: detectNetwork(),
      app_version: '1.0.0',
      language: navigator.language || 'unknown'
    }
  } catch (e) {
    return {}
  }
}

export function collectAppInfo(location, document, routeName = null) {
  try {
    let applicationTitle = ''
    try {
      // 尝试从 localStorage 获取
      const current_user = JSON.parse(localStorage.getItem('current_user') || 'null')
      // 如果没有专门的 site_info，尝试从用户关联的应用信息中找
      applicationTitle = document?.title || 'Streams Admin'
    } catch (e) {}

    return {
      url: window.location.href,
      path: location.pathname,
      title: document?.title || '',
      application_title: applicationTitle,
      referrer: document?.referrer || '',
      route_name: routeName
    }
  } catch (e) {
    return { path: location.pathname }
  }
}

export function collectUserInfo() {
  try {
    const userStr = localStorage.getItem('current_user');
    
    if (!userStr || userStr === 'null') {
      return null;
    }

    const currentUser = JSON.parse(userStr)
    if (currentUser && currentUser._id) {
      return {
        _id: currentUser._id,
        username: currentUser.username || '',
        display_name: currentUser.display_name || '',
        type: currentUser.type || 'normal'
      }
    }
    
    // 如果只有 ID 字符串
    if (typeof currentUser === 'string') {
      return { _id: currentUser }
    }
    
    if (currentUser?._id) {
      return { _id: currentUser._id }
    }
  } catch (e) {
    // 忽略错误
  }
  return null
}
